"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDescriptionContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const canvas_box_1 = require("../canvas-box");
const setDescriptionStyles = (0, styled_components_1.css) `
  padding: 0 0 0 3px;
  width: 100%;
`;
exports.StyledDescriptionContainer = (0, styled_components_1.default)(canvas_box_1.CanvasContainer) `
  background-color: ${(props) => props.backgroundColor};
  font-size: ${(props) => props.fontSize};
  text-align: ${(props) => props.textAlign};
  justify: ${(props) => props.justify};
  width: fit-content;
  ${setDescriptionStyles}
`;
